export default __webpack_public_path__ + "static/Quickinstallation_IN-6001_02-3e2212c46ab55374ba430e3275e59d08.webp";